import * as React from 'react'
import classNames from 'classnames'
import Link from 'next/link'

import {logEvent} from '@lib/gtm'

import {scrollIntoView} from './utils'

export const Solutions = () => {
  const [hoverIndex, setHoverIndex] = React.useState(-1)
  const data = [
    {
      title: 'Machinery',
      img: [
        '/images/ai/solutions/machinery.jpg',
        '/images/ai/solutions/machinery@2x.jpg',
      ],
      body: 'การใช้เครื่องจักรนั้นมีต้นทุนการทำงานอยู่เสมอ เพราะฉะนั้นการทำให้เครื่องจักรเกิดประสิทธิผลมากที่สุดจะช่วยให้องค์กรสามารถลดต้นทุนในการดำเนินงานได้ ในอุตสาหกรรมนี้ AI สามารถช่วยวางแผนการทำงานของเครื่องจักรภายใต้ข้อจำกัดต่าง ๆ เพื่อทำให้เครื่องจักรสามารถทำงานได้อย่างมีประสิทธิภาพมากที่สุด นอกจากนี้ AI ยังสามารถประมาณเวลาในการซ่อมบำรุงเครื่องจักรครั้งต่อไปและแจ้งเตือนผู้ดูแลหากเครื่องจักรใดกำลังจะมีปัญหา เพื่อให้ผู้ดูแลสามารถวางแผนซ่อมแซมเครื่องจักรนั้น ๆ ก่อนจะเกิดความเสียหาย',
      href: 'machinery',
    },
    {
      title: 'Automotive',
      img: [
        '/images/ai/solutions/automotive.jpg',
        '/images/ai/solutions/automotive@2x.jpg',
      ],
      body: 'AI สามารถนำมาใช้งานในอุตสาหกรรมยานยนต์ได้อย่างครบวงจร ไม่ว่าจะเป็นการตรวจสอบตำหนิและทำให้แน่ใจว่าชิ้นส่วนที่ได้ในแต่ละขั้นตอนสมบูรณ์ตามมาตรฐานของการผลิต รวมถึงใช้ประเมินค่าใช้จ่ายในการพ่นสี หรือซ่อมแซมความเสียหายที่เกิดจากการใช้งาน เพื่อช่วยอำนวยความสะดวกให้กับทั้งผู้ให้บริการ และลูกค้าที่มาใช้งาน ทั้งในด้านของค่าใช้จ่ายและเวลา',
      href: 'automotive',
    },
    {
      title: 'Textile',
      img: [
        '/images/ai/solutions/textile.jpg',
        '/images/ai/solutions/textile@2x.jpg',
      ],
      body: 'ในวงการอุตสาหกรรมสิ่งทอ ตำหนิที่พบในสินค้าจากกระบวนการผลิต ไม่ว่าจะเป็นสี ลวดลายหรือการทอผ้าจะทำให้มูลค่าของสินค้าลดลงอย่างมาก ในปัจจุบันการใช้แรงงานคนตรวจนั้นเป็นไปอย่างล่าช้า และมีโอกาสเกิดความผิดพลาดขึ้นได้ จุดนี้เองที่ AI จะเข้ามาช่วยลดเวลาที่ใช้ในการตรวจสอบคุณภาพ รวมถึงลดโอกาสที่จะส่งสินค้าที่มีตำหนิออกไปสู่ตลาด นอกจากนี้ AI ยังสามารถช่วยในการออกแบบลวดลายของผลิตภัณฑ์ใหม่ ๆ ได้อีกด้วย',
      href: 'textile',
    },
    {
      title: 'Food',
      img: [
        '/images/ai/solutions/food.jpg',
        '/images/ai/solutions/food@2x.jpg',
      ],
      body: 'AI สามารถเข้ามามีบทบาทในกระบวนการผลิตของอุตสาหกรรมอาหาร โดยช่วยในเรื่องของการควบคุมคุณภาพและมาตรฐานความสะอาดตั้งแต่ขั้นตอนการเตรียมวัตถุดิบ เพื่อลดปริมาณของเสียที่เกิดขึ้นระหว่างทาง รวมไปถึงการนำมาใช้ตรวจสอบรอยฉีกขาดในบรรจุภัณฑ์ นอกจากนี้ AI ยังสามารถช่วยตรวจตราพนักงานในส่วนการผลิตผ่านทางกล้องวงจรปิด เพื่อให้มั่นใจว่าพนักงานแต่งกายถูกต้องตามระเบียบและได้ปฏิบัติตามข้อกำหนดด้านความสะอาดขององค์กร',
      href: 'food',
    },
    {
      title: 'Electronics',
      img: [
        '/images/ai/solutions/electornics.jpg',
        '/images/ai/solutions/electornics@2x.jpg',
      ],
      body: 'การผลิตอุปกรณ์อิเล็กทรอนิกส์นั้นเป็นงานที่ต้องการความละเอียดสูง ในอุตสาหกรรมนี้ สามารถนำ AI ไปใช้ในงานหลาย ๆ ด้าน เช่น ตรวจสอบความถูกต้องสมบูรณ์ของวงจรไฟฟ้าบนอุปกรณ์อิเล็กทรอนิกส์แต่ละชนิด เพื่อช่วยควบคุมคุณภาพของอุปกรณ์ และคัดแยกส่วนที่ไม่ได้มาตรฐานออกจากล็อตของสินค้าที่จะจัดส่งออกจำหน่าย',
      href: '',
    },
    {
      title: 'Agriculture and Livestock',
      img: [
        '/images/ai/solutions/agriculture.jpg',
        '/images/ai/solutions/agriculture@2x.jpg',
      ],
      body: 'การประยุกต์ใช้ระบบ AI สำหรับบริหารจัดการแปลงพืชผลและปศุสัตว์ ช่วยอำนวยความสะดวกและลดปริมาณงานของพนักงานในการประเมินสุขภาพพืชในแต่ละแปลงพื้นที่ทำให้สามารถนำข้อมูลที่ได้ไปใช้ประกอบการวางแผน เพื่อดูแลและจัดการแปลงพืชอย่างเหมาะสม นอกจากนี้ยังสามารถใช้ AI วิเคราะห์ปริมาณพืชผลหลังเก็บเกี่ยวจากภาพถ่ายทางอากาศได้อีกด้วย ในด้านของการปศุสัตว์ AI สามารถวิเคราะห์พฤติกรรมเพื่อตรวจจับอาการของสัตว์ที่ป่วยหรือตายในโรงเลี้ยงและแจ้งเตือนต่อเกษตรกร ทำให้สามารถคัดแยกหรือกำจัดสัตว์ที่ป่วยหรือตายในโรงเลี้ยงได้อย่างทันท่วงที',
      href: 'agriculture',
    },
  ]

  const handleMouseEnter = (index: number) => () => setHoverIndex(index)
  const handleMouseLeave = () => setHoverIndex(-1)

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const {hash} = event.currentTarget

    event.preventDefault()
    scrollIntoView(hash)
    logEvent({
      ga: {
        category: 'AI Consultation',
        action: `Click Get In Touch`,
        label: 'AI Solutions in Industry',
      },
    })
  }

  return (
    <div className='AI__solutions' id='solutions'>
      <div className='AI__solutions__title'>
        <h2>
          <span>ค้นหา AI</span>
          <span>Solutions</span>
          <span>สำหรับ</span>
          <span>ธุรกิจ</span>
          <span>ของคุณ</span>
        </h2>
        <a href='#contact' title='Get in touch' onClick={handleClick}>
          <span>Get in touch</span>
        </a>
      </div>

      <ul className='AI__solutions__list'>
        {data.map((item, index) => {
          return (
            <li
              key={index}
              className={classNames('AI__solutions__item', {
                'AI__solutions__item--hover': index === hoverIndex,
              })}
              onMouseEnter={handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <h4>{item.title}</h4>
              <p>{item.body}</p>
              <div>
                <div className='AI__solutions__aspect-ratio'>
                  <img
                    src={item.img[0]}
                    srcSet={`${item.img[1]} 2x`}
                    alt={item.title}
                    loading='lazy'
                  />
                </div>
                <footer
                  className={classNames('AI__solutions__footer', {
                    'AI__solutions__footer--hidden': item.href === '',
                  })}
                >
                  <Link href={`/ai-consultation/${item.href}`}>
                    <a
                      className='AI__solutions__button'
                      onClick={() => {
                        logEvent({
                          ga: {
                            category: 'AI Consultation',
                            action: 'Click Read More',
                            label: item.title,
                          },
                        })
                      }}
                    >
                      <span>Read More</span>
                    </a>
                  </Link>
                </footer>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
